module.exports = __webpack_public_path__ + "static/media/c-pop-up-3.e2b8d8ef.png";